import React, { Fragment, useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { getInstance } from '../config/token';
import { Button, Modal, Badge } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { InputLabel } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: 300
  },
  indeterminateColor: {
    color: "#f50057"
  },
  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  }
}));

const AddNote = (props) => {

  const [loadingButton, setLoadingButton] = useState(false);
  const [noteTitle, setNoteTitle] = useState("");
  const [noteContent, setNoteContent] = useState("");
  const [selected, setSelected] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState([]);
  const [options, setOption] = useState([])

  const isAllSelected =
    options.length > 0 && selected.length === options.length;

  useEffect(() => {
    let config = getInstance('GET', `/api/get_employee/`);
    axios(config).then((res) => {
      console.log("users", res.data)
      let userArray = []
      for (let i = 0; i < res.data.length; i++) {
        userArray.push({ "label": res.data[i].first_name, "value": res.data[i].id })
      }
      setOption(userArray)
    })
  }, [])

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === options.length ? [] : options);
      if (selected.length === options.length) {
        setSelected([])
        setSelectedLabel([])
      } else {
        let usrArry = []
        let usrArrayName = []
        for (let j = 0; j < options.length; j++) {
          usrArry.push(options[j].value)
          usrArrayName.push(options[j].label)
        }
        setSelected(usrArry)
        setSelectedLabel(usrArrayName)
      }
      return;
    }
    setSelected(value);
    let labelArr = []
    for (let k = 0; k < value.length; k++) {
      labelArr.push(options.find(element => element.value == value[k]).label)
    }
    setSelectedLabel(labelArr)
    console.log(value)
    console.log(selected)
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: 1,
    p: 8,
  };
  const responsiveStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: 1,
    p: 3,
  };



  const classes = useStyles();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: "auto",
        // top: "160px !important"
        borderRadius : "0.75rem",
        border: "1px solid #3D455A"
      }
    },
    variant: "menu"
  };


  const newNote = () => {
    let errFlag = false;
    if (noteTitle == "") {
      errFlag = true;
      toast.error("title is required.", {
        position: "top-right",
      });
      // setErrMsg("Title is required.");
    } else if (noteContent == "") {
      errFlag = true;
      toast.error("note is required.", {
        position: "top-right",
      });
      // setErrMsg("Title can not be more than 255 characters.");
    }
    if (!errFlag) {
      let requestObj = {
        user: selected,
        note: noteContent,
        title: noteTitle
      }
      setLoadingButton(true);
      let config = getInstance('POST', `/api/create_note`, requestObj);
      axios(config)
        .then((res) => {
          setLoadingButton(false)
          setNoteContent("");
          setNoteTitle("");
          props.closeNotePopup()
          props.fetchMyNotes()

        })
        .catch((err) => {
          setLoadingButton(false)
          let msg = "Something went wrong!"
          toast.error(msg, {
            position: "top-right",
          });
        });
    }

  };

  return (
    // <Box sx={responsiveStyle} md={style}>
    <Fragment>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
    <Modal
      show={props.isModalOpen}
      // onHide={() => this.setState({ cameraModal: false })}
      className="modal fade"
      id="statusModal"
    >
      <div className="">
        <div className="modal-header">
          <h5 className="modal-title">Create Note</h5>
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => props.closeNotePopup()}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body">
          {/* <Typography variant="h2" sx={{ mb: 2 }}>
            Add Note
          </Typography> */}
          <form
          onSubmit={(e) => {
            e.preventDefault();
            // setNewEvent(false);
          }}
          >
            <div className="form-group">
              {/* <InputLabel id="mutiple-select-label">Select User</InputLabel> */}
              <div className="">
              {/* <label className="text-black font-w500">Select User</label> */}
              <InputLabel id="demo-simple-select-label">Select User</InputLabel>
                <Select
                  labelId="mutiple-select-label"
                  native={false}
                  multiple
                  variant="outlined"
                  label="Select User"
                  value={selected}
                  onChange={handleChange}
                  renderValue={(selected) => selectedLabel.join(", ")}
                  MenuProps={MenuProps}
                  disabled={loadingButton}
                  style={{width : "100%"}}
                >
                  <MenuItem
                    value="all"
                    classes={{
                      root: isAllSelected ? classes.selectedAll : ""
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        classes={{ indeterminate: classes.indeterminateColor }}
                        checked={isAllSelected}
                        indeterminate={
                          selected.length > 0 && selected.length < options.length
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.selectAllText }}
                      primary="Select All"
                    />
                  </MenuItem>
                  {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      <ListItemIcon>
                        <Checkbox checked={selected.indexOf(option.value) > -1} />
                      </ListItemIcon>
                      <ListItemText primary={option.label}>{option.label} </ListItemText>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="form-group">
              <label className="text-black font-w500">Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control form-border-color"
                  maxLength={255}
                  required
                  value={noteTitle}
                  onChange={(e) => setNoteTitle(e.target.value)}
                />

              </div>
              <div className="form-group">
              <label className="text-black font-w500">Note</label>
                <textarea
                  name="message"
                  id="textarea"
                  cols={30}
                  rows={5}
                  // maxLength={1500}
                  className="form-control form-border-color"
                  defaultValue={""}
                  required
                  onChange={(e) => setNoteContent(e.target.value)}
                />

              </div>
              <div className="form-group" style={{ textAlign: "center" }}>
                <input
                  disabled={loadingButton}
                  // style={{ marginRight: "10px" }}
                  type="submit"
                  value="Create Note"
                  className="btn btn-primary"
                  onClick={() => newNote()}
                />
              </div>
              {/* <LoadingButton
              loading={loadingButton}
              type="submit"
              variant="outlined"
              sx={{ mx: "auto" }}
            >
              Add
            </LoadingButton> */}
            </div>
          </form>
        </div>
      </div>
    </Modal>
    </Fragment>

    // </Box>
  );
}

export default AddNote;
